"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = debounce;
function debounce(fn, wait) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        return new Promise((resolve, reject) => {
            timer = setTimeout(() => {
                fn.apply(this, args).then(resolve).catch(reject);
            }, wait);
        });
    };
}
//# sourceMappingURL=debounce.js.map